import { dashboard } from "../endpoints/dashboard.endpoints";
import $axios from "../http/accessor";

const DashboardService = {
  getStatisticsData: () => {
    return $axios.get(dashboard.statistics);
  },
  getAnalyticsData: (days?: number) => {
    const params = days ? { days } : {};
    return $axios.get(dashboard.analytics, { params });
  },
};

export default DashboardService;
